import { render } from "./OrderPending.vue?vue&type=template&id=97a36792&scoped=true"
import script from "./OrderPending.vue?vue&type=script&lang=js"
export * from "./OrderPending.vue?vue&type=script&lang=js"

import "./OrderPending.vue?vue&type=style&index=0&id=97a36792&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97a36792"]])

export default __exports__